
export const FILTER_GROUP_VISUAL_TYPE_ColorsWithColumns = 'ColorsWithColumns';
export const FILTER_GROUP_VISUAL_TYPE_ColorsWithDescription = 'ColorsWithDescription';
export const FILTER_GROUP_VISUAL_TYPE_ImageList = 'ImageList';
export const FILTER_GROUP_VISUAL_TYPE_ItemsWithThumbnails = 'ItemsWithThumbnails';
export const FILTER_GROUP_VISUAL_TYPE_ListWithCheckBoxes = 'ListWithCheckBoxes';

export const filterGroupVisualTypeDescription = type => {
  switch (type){
    case FILTER_GROUP_VISUAL_TYPE_ColorsWithColumns:
      return 'Color Grid';
    case FILTER_GROUP_VISUAL_TYPE_ColorsWithDescription:
      return 'Colors with name';
    case FILTER_GROUP_VISUAL_TYPE_ImageList:
      return 'Icon only';
    case FILTER_GROUP_VISUAL_TYPE_ItemsWithThumbnails:
      return 'Icons with description';
    case FILTER_GROUP_VISUAL_TYPE_ListWithCheckBoxes:
      return 'Multiple Choice';
  }
}

